module.exports = __webpack_public_path__ + "img/32.89ff0f29.svg";